<template>
  <div>
    <div style="padding: 10px;">
      <div class="user-header-k">
        <div class="search-box">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="搜索：">
                    <el-input
                      v-model="keyword"
                      placeholder="请输入关键字"
                      @keyup.enter.native="searchTo()"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button type="primary" @click="searchTo()">查询</el-button>
                  </el-form-item>
              </el-form>
        </div>
      </div>
      <div class="pagination-table-k">
        <pagination-table style="width: 98%;margin-left: auto;margin-right: auto;" ref="table" :data="tableData"
          :columns="columns" :loader="fetchUserInfo" :async="true" :pageSizes="[20]">
        </pagination-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { getToken } from '@/utils';
  export default {
    data() {
      return {
        headers: {
          apiKey: getToken()
        },
        pageSize:20,
        tableData: [],
        tableLoading: false,
        page: 0,
        keyword: '',
        columns: [
          {
            prop: 'userCode',
            label: '用户名'
          },
          {
            prop: 'createTime',
            label: '日期'
          },
          {
            prop: 'eventIp',
            label: 'IP'
          },
        ],
      };
    },

    methods: {
      async fetchUserInfo(options) {
        this.tableLoading = true;
        const res = await this.$fetch('/windfarm/getLoginLogList', {
          module: 'manage',
          params: { pageNo: options.page, keyword: this.keyword , pageSize:this.pageSize},
          showError: true
        });
        const data = res.data.data.rows;
     
        this.tableData = data;
        this.tableLoading = false;
        return {
          data: res.data.data.rows,
          total: res.data.data.total
        };
      },
      searchTo() {
        this.$refs.table.load({ page: 1 });
      }
    },
    created() {

    }
  };
</script>

<style lang="less" scoped>
  .user-header-k {
    width: 98%;
    display: flex;
    justify-content: space-between;
    margin: 15px auto;
    position: relative;
  }

</style>